import React from 'react';
import { AppShell } from '@/components/layout/AppShell';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { RoleBadge } from '@/components/common/RoleBadge';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { daysUntil, INTERN_ROLES } from '@/lib/constants';

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => { await logout(); navigate('/login'); };

  return (
    <AppShell title="Profile">
      <div className="max-w-lg" data-testid="profile-page">
        <Card>
          <CardHeader><CardTitle className="font-display">Account</CardTitle></CardHeader>
          <CardContent className="space-y-3 text-sm">
            <div><div className="text-xs text-muted-foreground">Name</div><div className="font-medium">{user?.name}</div></div>
            <div><div className="text-xs text-muted-foreground">Email</div><div className="font-mono">{user?.email}</div></div>
            <div className="flex items-center gap-2"><div className="text-xs text-muted-foreground">Role:</div><RoleBadge role={user?.role} /></div>
            {user?.expires_at ? (
              <div><div className="text-xs text-muted-foreground">Access expires</div><div className="font-medium">{new Date(user.expires_at).toLocaleString()} <span className="text-muted-foreground">({daysUntil(user.expires_at)} days)</span></div></div>
            ) : null}
            <div><div className="text-xs text-muted-foreground">Google linked</div><div>{user?.google_linked ? 'Yes' : 'No'}</div></div>
            <div className="pt-2"><Button variant="outline" onClick={handleLogout} data-testid="profile-logout-button"><LogOut className="h-4 w-4 mr-2" />Sign out</Button></div>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
